/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrTemplateColumn } from './igr-template-column';
import { TemplateColumn } from './TemplateColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrTemplateColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrTemplateColumnModule() {
    }
    IgrTemplateColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrTemplateColumn", IgrTemplateColumn);
        TypeRegistrar.register("TemplateColumn", TemplateColumn.$type);
    };
    return IgrTemplateColumnModule;
}());
export { IgrTemplateColumnModule };
//# sourceMappingURL=igr-template-column-module.js.map
